module.exports = __webpack_public_path__ + "img/1513932198.462cd36e.jpg";